module.exports = __webpack_public_path__ + "static/media/reporte_portal.57674789.png";